<template>
  <div>
    <el-form label-width="140PX" :model="datas" ref="form" label-position="right" :rules="validationRules">
      <el-form-item label="父节点" prop="pid">
<!--        <treePicker :treePicker="treePicker" style="width: 500px"></treePicker>-->
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input style="width: 500px" type="text" v-model="datas.name" />
      </el-form-item>
      <el-form-item label="负责人" prop="headName">
        <el-select
          v-model="datas.headName"
          @change="changeHead"
          class="headName"
          style="width: 500px"
          placeholder="请选择负责人"
          filterable
          remote
          :remote-method="getHeader"
          :loading="loading"
        >
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电话" prop="phoneNum">
        <el-input type="text" v-model="datas.phoneNum" style="width: 500px" />
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input type="text" v-model="datas.address" style="width: 500px" />
      </el-form-item>
      <el-form-item label="顺序" prop="orderNum">
        <el-input-number v-model="datas.orderNum" :min="1" style="width: 500px" size="mini"></el-input-number>
      </el-form-item>
      <div style="text-align: center; padding-left: 60px">
        <el-button size="small" style="width: 150px" type="primary" @click="submit">提交</el-button>
        <el-button size="small" style="width: 150px; margin-left: 20px" type="danger" @click="close()">关闭</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import apiEap from '../../js/eap_api';
export default {
  props: {
    params: Object
  },
  components: {
    // treePicker
  },
  data() {
    return {
      validationRules: {
        required: ['pid', 'name']
      },
      treePicker: {
        url: `${$api_eap.team.tree}`,
        params: {},
        toLabel: 'name'
      },
      datas: {
        id: null,
        name: null,
        address: null,
        orderNum: null,
        phoneNum: null,
        pid: null,
        headId: '',
        headName: ''
      },
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        datas: []
      },
      options: [],
      team: '',
      loading: false,
      list: []
    };
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        this.datas = newVal;
      }
    }
  },
  mounted() {
    this.tree();
    // 根据id获取商品数据
    if (this.params.id) {
      this.leftForById();
    }
    if (this.params.teamId) {
      this.$store.dispatch('changeNodeName', this.params.teamName);
      this.$store.dispatch('changeTreePick', this.params.teamId);
    }
  },
  methods: {
    // 选择组织负责人
    changeHead() {
      this.options = [];
    },
    tree() {
      httpKit.post($api_eap.team.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.param.datas = res.data.data;
          }
        }
      });
    },
    leftForById() {
      let par = { teamId: this.params.id };
      httpKit.post($api_eap.team.info, par).then(res => {
        if (res.data.code === '200') {
          this.datas = res.data.data;
          let obj = findInTree(this.params.tree, this.datas.pid, 'id');
          this.$store.dispatch('changeNodeName', obj.label);
          this.$store.dispatch('changeTreePick', this.datas.pid);
        }
      });
    },
    submit() {
      this.datas.pid = this.$store.state.employee.treePick;
      if (!this.datas.name || this.datas.name === '') {
        this.$message.error('组织名称不能为空');
        return false;
      }
      if (!this.datas.pid || this.datas.pid === '') {
        this.$confirm('不选父节点将添加 根节点, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.datas.pid = -1;
            this.save();
          })
          .catch(() => {
            this.$message.warning('已取消');
          });
      } else {
        this.save();
      }
    },
    save() {
      this.datas.headId = findInTree(this.list, this.datas.headName, 'name').id;
      const loading = this.$loading({
        lock: true,
        text: '保存中，请稍等',
        spinner: 'el-icon-loading'
      });
      httpKit.post($api_eap.team.save, this.datas).then(res => {
        loading.close();
        if (res.data.code === '200') {
          this.$message.success(res.data.msg);
          this.success();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getHeader(keyword) {
      this.loading = true;
      httpKit.post(apiEap.user.autocompleteCheck, { keyword }).then(res => {
        this.loading = false;
        if (res.data.code === '200') {
          this.options = res.data.data;
          this.list = Object.assign([], this.options);
        } else {
          this.options = [];
        }
      });
    },
    success() {
      this.$emit('success', this.params.teamId);
    },
    close() {
      this.$emit('close');
      this.$store.dispatch('changeNodeName', '');
      this.$store.dispatch('changeTreePick', '');
      this.datas = '';
    }
  }
};
</script>
<style lang="less">
.headName .el-input .el-input__icon {
  line-height: 32px;
}
</style>
